<div class="row">
    <div class="col-12">
        <div class="promotion-background rounded shadow">
            <div class="row d-flex align-items-center px-10">
                <div class="col-12 col-sm-12 col-md">
                    <ng-container *ngFor="let item of items">
                        <div class="text-white col-12" 
                            [ngClass]="item?.alignment" 
                            [style.padding-top.px]="item?.padding"
                            *ngIf="item?.type == 'TEXT' && item?.title != 'Link'" 
                        >
                            <h2 style="font-size: 28px;">{{ item?.content }}</h2>
                        </div>
            
                        <div class="text-white col-12">
                            <div class="font-size-16"
                                [ngClass]="item?.alignment" 
                                [style.padding-top.px]="item?.padding"
                                [style.padding-bottom.px]="item?.padding" 
                                *ngIf="item?.type == 'TEXTAREA'" 
                            >
                                <p>{{ item?.content }}</p>
                            </div>
                        </div>

                        <div class="text-white col-12">
                            <div [ngClass]="item?.alignment" 
                                [style.padding-top.px]="item?.padding"
                                [style.padding-bottom.px]="item?.padding" 
                                *ngIf="item?.title == 'Link'" 
                            >
                                <ng-container *ngIf="item?.content?.includes('http')">
                                    <a href="{{ item?.content }}" target="_blank">
                                        <button type="button" class="px-20 btn btn-primary btn-lg rounded-pill font-weight-bold font-size-16">Attend</button>
                                    </a>
                                </ng-container>

                                <ng-container *ngIf="!item?.content?.includes('http')">
                                    <a routerLink="{{ item?.content }}">
                                        <button type="button" class="px-20 btn btn-primary btn-lg rounded-pill font-weight-bold font-size-16">Attend</button>
                                    </a>
                                </ng-container>
                                
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>        
    </div>
</div>